<template>
  <div class="page-content">
    <div class="search-bar">
      <div class="search-input-wrapper">
        <i class="el-icon-search search-icon"></i>
        <input
          v-model="searchText"
          type="text"
          class="search-input"
          placeholder="搜索操作内容..."
          @keyup.enter="handleSearch"
        />
      </div>
      <div class="action-buttons">
        <button class="btn btn-secondary" @click="exportLogs">
          <i class="ri-download-cloud-2-line"></i>
          导出日志
        </button>
      </div>
    </div>

    <div class="card">
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>时间</th>
              <th>操作人</th>
              <th>操作类型</th>
              <th>操作内容</th>
              <th>IP地址</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in logs" :key="log.id" class="table-row">
              <td class="time-cell">{{ log.createdTime }}</td>
              <td>
                <div class="operator-info">
                  <div class="operator-avatar">
                    <i class="el-icon-user-solid"></i>
                  </div>
                  <span class="operator-name">{{ log.operatorName || '-' }}</span>
                </div>
              </td>
              <td>
                <span class="badge" :class="getTypeClass(log.operationType)">
                  {{ log.operationType || '-' }}
                </span>
              </td>
              <td>
                <span class="content-text">{{ log.detail || '-' }}</span>
              </td>
              <td>
                <span class="ip-text">
                  <i class="ri-global-line"></i>
                  {{ log.ip || '-' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-bar">
        <span class="pagination-info">显示 {{ (currentPage - 1) * pageSize + 1 }} 到 {{ Math.min(currentPage * pageSize, total) }} 条，共 {{ total }} 条</span>
        <div class="pagination">
          <button class="page-btn" :disabled="currentPage === 1" @click="currentPage--">上一页</button>
          <button
            v-for="page in visiblePages"
            :key="page"
            class="page-btn"
            :class="{ active: page === currentPage, ellipsis: page === '...' }"
            :disabled="page === '...'"
            @click="page !== '...' && (currentPage = page)"
          >
            {{ page }}
          </button>
          <button class="page-btn" :disabled="currentPage === totalPages" @click="currentPage++">下一页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogsManagement',
  data() {
    return {
      logs: [],
      searchText: '',
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    },
    visiblePages() {
      const pages = []
      const total = this.totalPages
      const current = this.currentPage
      if (total <= 5) {
        for (let i = 1; i <= total; i++) pages.push(i)
      } else {
        if (current <= 3) {
          pages.push(1, 2, 3, 4, '...', total)
        } else if (current >= total - 2) {
          pages.push(1, '...', total - 3, total - 2, total - 1, total)
        } else {
          pages.push(1, '...', current - 1, current, current + 1, '...', total)
        }
      }
      return pages
    }
  },
  mounted() {
    this.loadLogs()
  },
  watch: {
    currentPage() {
      this.loadLogs()
    }
  },
  methods: {
    async loadLogs() {
      try {
        const response = await this.$http({
          url: '/admin/system/log/list',
          method: 'get',
          params: {
            page: this.currentPage,
            size: this.pageSize,
            keyword: this.searchText
          }
        })
        this.logs = response || []
        this.total = this.logs.length
      } catch (error) {
        this.$message.error('加载日志列表失败')
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.loadLogs()
    },
    exportLogs() {
      this.$message.info('正在导出日志...')
    },
    getTypeClass(type) {
      const typeMap = {
        'login': 'badge-info',
        'logout': 'badge-default',
        'create': 'badge-success',
        'update': 'badge-warning',
        'delete': 'badge-danger',
        'block': 'badge-danger',
        'unblock': 'badge-success'
      }
      return typeMap[type] || 'badge-default'
    }
  }
}
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.css');

.page-content {
  max-width: 100%;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
}

.search-input-wrapper {
  position: relative;
  max-width: 320px;
  width: 100%;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 16px;
}

.search-input {
  width: 100%;
  padding: 10px 12px 10px 40px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
  background: #fff;
}

.search-input:focus {
  border-color: #07c160;
  box-shadow: 0 0 0 3px rgba(7, 193, 96, 0.1);
}

.search-input::placeholder {
  color: #94a3b8;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.btn i {
  font-size: 16px;
}

.btn-secondary {
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #64748b;
}

.btn-secondary:hover {
  background: #f8fafc;
  border-color: #07c160;
  color: #07c160;
}

.card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.table-wrapper {
  overflow-x: auto;
  max-height: calc(100vh - 380px);
  overflow-y: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.data-table thead {
  background: #f8fafc;
}

.data-table th {
  padding: 16px 24px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #e2e8f0;
}

.data-table td {
  padding: 16px 24px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 14px;
  color: #334155;
}

.table-row:hover {
  background: #f9fafb;
}

.time-cell {
  color: #64748b;
  font-size: 13px;
  white-space: nowrap;
}

.operator-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.operator-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 12px;
}

.operator-name {
  color: #334155;
}

.badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
}

.badge-default {
  background: #f1f5f9;
  color: #64748b;
}

.badge-info {
  background: #dbeafe;
  color: #2563eb;
}

.badge-success {
  background: #dcfce7;
  color: #16a34a;
}

.badge-warning {
  background: #fef3c7;
  color: #d97706;
}

.badge-danger {
  background: #fee2e2;
  color: #dc2626;
}

.content-text {
  color: #334155;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

.ip-text {
  color: #64748b;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.ip-text i {
  font-size: 14px;
}

.pagination-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.pagination-info {
  font-size: 14px;
  color: #64748b;
}

.pagination {
  display: flex;
  gap: 4px;
}

.page-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  color: #64748b;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
  border-color: #07c160;
  color: #07c160;
}

.page-btn.active {
  background: #07c160;
  border-color: #07c160;
  color: #fff;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn.ellipsis {
  border: none;
  background: transparent;
  cursor: default;
}
</style>